<template>
  <div data-testid="cap-setting">
    <Field
      :label="enableCapsLabel"
      :has-tooltip="true"
      :tooltip-text="enableCapsTooltip"
    >
      <template #element>
        <ValidationProvider slim>
          <div class="col-md-8 col-sm-8">
            <NzToggle
              data-testid="cap-setting-toggle-caps"
              v-model="showCaps"
              :disabled="readonly"
              @onToggle="handleEnableCapSettingsChange"
            />
          </div>
        </ValidationProvider>
      </template>
    </Field>
    <div v-if="showCaps" data-testid="cap-setting-caps-wrapper">
      <div v-for="(cap, index) in capSettings" :key="index">
        <Field
          :label="
            $t(capFieldsTranslation[cap.key].label, {
              capCriteria: translationDictionary['capCriteria'],
            })
          "
          :has-tooltip="true"
          :tooltip-text="
            $t(capFieldsTranslation[cap.key].tooltip, {
              capCategory: translationDictionary['capCategory'],
            })
          "
        >
          <template #element>
            <ValidationProvider slim>
              <div class="col-xs-3 col-sm-2 col-md-2 col-lg-2 toggle-wrap">
                <NzToggle
                  :disabled="readonly"
                  :data-testid="`cap-setting-${cap.key}`"
                  :value="parseBoolean(cap.model)"
                  @onToggle="onToggle(cap.key, $event)"
                />
              </div>

              <div
                class="col-xs-4 col-sm-2 col-md-1 col-lg-2"
                v-if="cap.model > -1"
              >
                <span
                  class="currency currency-with-toggle"
                  data-testid="cap-setting-prefix"
                  v-if="cap.capSettingType === capSettingType.SUM"
                  >$</span
                >
                <input
                  data-testid="cap-setting-cap-field-input"
                  type="number"
                  class="form-control m-b-0"
                  min="0"
                  step="0.01"
                  :readonly="readonly"
                  @input="onSetCapField(cap.key, +$event.target.value)"
                  :value="cap.modelSettings"
                  @wheel="$event.target.blur()"
                />
              </div>
              <div
                class="col-xs-3 col-sm-7 col-md-3 form-control-static"
                v-if="cap.model < 0"
                data-testid="cap-setting-none"
              >
                {{ $t('NONE_TEXT') }}
              </div>
              <div
                class="col-xs-3 col-sm-7 col-md-3 form-control-static"
                v-if="cap.model === 0"
              >
                {{ $t('CLOSED') }}
              </div>
            </ValidationProvider>
          </template>
        </Field>
      </div>
    </div>
  </div>
</template>

<script>
import sharedMessages from '@/core/locales';
import messages from './locales';
import Field from '@/core/components/LabelAndElement/LabelAndElement.vue';
import NzToggle from '@/core/components/nzToggle/nzToggle.vue';
import { capSettingsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
export default {
  name: 'CapSetting',
  components: {
    Field,
    NzToggle,
  },
  props: {
    capSettingsType: {
      type: String,
      default: () => capSettingsService.defaultCapSettingsType,
    },
    callCaps: {
      type: Object,
      default: () => ({}),
    },
    settingsObjectContainer: {
      type: Object,
      default: () => ({}),
    },
    translationDictionary: {
      type: Object,
      required: true,
    },
    enableCapsLabel: {
      type: String,
      required: true,
    },
    enableCapsTooltip: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    capFieldsTranslation: {
      type: Object,
      default: () => {
        return capSettingsService.commonCapFieldTranslations;
      },
    },
    additionalCapSettings: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showCaps: false,
    };
  },
  computed: {
    capSettingType() {
      return capSettingsService.capSettingType;
    },
    capSettings() {
      return capSettingsService.getCapSettings(
        this.callCaps,
        this.settingsObjectContainer,
        this.capSettingsType,
        this.additionalCapSettings
      );
    },
  },
  methods: {
    setShowCaps() {
      this.showCaps = this.capSettings.some((cap) => cap.modelSettings > -1);
    },
    handleEnableCapSettingsChange(enableCapsFlag) {
      if (enableCapsFlag) return;

      this.$emit('remove-caps');
    },
    onToggle(capKey, value) {
      if (this.callCaps) {
        const newCallCaps = {
          ...this.callCaps,
          [capKey]: value ? 1 : value === false ? -1 : 0,
        };
        this.$emit('change-call-caps', newCallCaps);
      }
    },
    onSetCapField(capKey, value) {
      if (this.settingsObjectContainer) {
        const newSettingsObjectContainer = {
          ...this.settingsObjectContainer,
          [capKey]: value,
        };
        this.$emit(
          'change-settings-object-container',
          newSettingsObjectContainer
        );
      }
    },
    parseBoolean(numberValue) {
      if (numberValue <= 0) return false;

      return true;
    },
  },
  created() {
    this.setShowCaps();
  },
  i18n: {
    locale: 'en',
    sharedMessages,
    messages,
  },
};
</script>

<style>
</style>